// extracted by mini-css-extract-plugin
module.exports = {"emojiBox":"Emoticons_emojiBox__3Koxf","minimal":"Emoticons_minimal__1rEMq"};